function formatToCurrency(amount) {
  return amount
    .toFixed(0)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,")
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// current filter category the user is engaging
let current_category = "";

document.addEventListener("DOMContentLoaded", function (event) {
  const filterButtons = document.querySelectorAll("button[data-tag]");

  const STOREFRONT_ACCESS_TOKEN = "40c377e97e9a27dc4e1589a3ed8bd2f3";
  const GRAPHQL_URL = "/api/2023-01/graphql.json";

  const GRAPHQL_BODY = (query) => {
    return {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        "Content-Type": "application/graphql",
        "cache-control": "no-cache",
        pragma: "no-cache",
      },
      body: query,
    };
  };

  const fetchStore = async (query) => {
    console.log("Fetch Settings", GRAPHQL_BODY);
    if (!STOREFRONT_ACCESS_TOKEN) return;
    return await fetch(GRAPHQL_URL, GRAPHQL_BODY(query));
  };

  const getAvailableTagsQuery = (query, sort, id) => {
    const q = `query getAvailableTags {
				products(first: 50${id !== "" ? `,after: "${id}"` : ""}, sortKey: ${
      sort == ""
        ? "RELEVANCE"
        : sort == "UPDATED AT"
        ? "UPDATED_AT, reverse: true"
        : sort
    }, query: "${query}") {
					nodes {
                        tags
					}
				}
			}`;

    return q;
  };

  const getCollectionProductsQuery = (handle, id) => {
    const q = `query getCollectionProducts {
  
    collection(handle: "${handle}") {
      products(first: 50, sortKey: COLLECTION_DEFAULT${
        id !== "" ? `,after: "${id}"` : ""
      }) 
      {
            pageInfo{
                hasNextPage
                startCursor
                endCursor
            }

            nodes {

              collections(first: 10) {
                  nodes {
                      handle
                  }
              }
              title
              totalInventory
              productType
              handle
              id
              tags
              onlineStoreUrl
              options(first: 3) {
                id
                name
                values
              }
              images(first: 2) {
                nodes {
                  altText
                                  width
                                  height
                  url
                }
              }
              metafield(namespace: "custom", key: "parent_product_id") {
                value
              }
              variants(first: 1) {
                nodes {
                                  
                                  price {
                                  amount
                                  }
                  sku
                }
              }
            }
          }
				}
			}`;

    return q;
  };

  const getProductsQuery = (query, sort, id) => {
    const q = `query getProducts {
				products(first: 50${id !== "" ? `,after: "${id}"` : ""}, sortKey: ${
      sort == ""
        ? "RELEVANCE"
        : sort == "UPDATED AT"
        ? "UPDATED_AT, reverse: true"
        : sort
    }, query: "${query}") {

                    pageInfo{
                        hasNextPage
                        startCursor
                        endCursor
                    }


					nodes {

                        collections(first: 10) {
                            nodes {
                                handle
                            }
                        }
						title
                        totalInventory
                        productType
						handle
						id
                        tags
						onlineStoreUrl
						options(first: 3) {
							id
							name
							values
						}
						images(first: 2) {
							nodes {
								altText
                                width
                                height
								url
							}
						}
						metafield(namespace: "custom", key: "parent_product_id") {
							value
						}
						variants(first: 1) {
							nodes {
                                
                                price {
                                amount
                                }
								sku
							}
						}
					}
				}
			}`;

    return q;
  };

  const getAdaptiveSrc = (src, size) => {
    if (!src) return;
    const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
    const currentExtension = imageExtensions.find((ext) => src.includes(ext));

    if (!currentExtension) return src;

    const imageSize = size ? size : Math.max(this.$el.offsetWidth, 10);

    const srcParts = src.split(currentExtension);
    srcParts[0] = `${srcParts[0]}_${imageSize}x`;
    const adaptiveSrc = srcParts.join(currentExtension);

    return adaptiveSrc;
  };

  const productTemplate = (product) => {
    const get_artist = product.tags.filter((v) => v.includes("Artist_"));
    const artist = get_artist.length ? get_artist[0].split("_")[1] : "";

    const get_medium = product.tags.filter((v) => v.includes("Medium_"));
    const medium = get_medium.length ? get_medium[0].split("_")[1] : "";

    const AspectRatio =
      product.images.nodes[0].width / product.images.nodes[0].height;

    const template = `
        <div class="Productlist__Itemss" prod-price="${formatToCurrency(
          parseFloat(product.variants.nodes[0].price.amount)
        )
          .replace(",", "")
          .replace(".", "")}"> 
        
        
        <div class="ProductItem ">
            <div class="ProductItem__Wrapper">
                <a href="/collections/all/products/${
                  product.handle
                }" class="ProductItem__ImageWrapper ">
                    <div class="AspectRatio AspectRatio--withFallback" style="--aspect-ratio: ${AspectRatio}">
                        <img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2048]" data-sizes="auto" alt="${
                          product.images.nodes[0].altText
                        }" data-media-id="28753429889190" 
                        srcset="${getAdaptiveSrc(
                          product.images.nodes[0].url,
                          540
                        )} 540w, 
                        ${getAdaptiveSrc(
                          product.images.nodes[0].url,
                          720
                        )} 720w, 
                        ${getAdaptiveSrc(
                          product.images.nodes[0].url,
                          540
                        )} 900w">
                        <span class="Product__Image__Shop">${
  product.tags.includes("onrequest")
    ? "ON REQUEST"
    : product.totalInventory > 0
      ? "BUY"
      : "SOLD"
}</span>
                    </div>
                </a>


                ${
                  product.totalInventory == 0
                    ? '<div class="ProductItem__LabelList"><span class="ProductItem__Label Heading Text--subdued">SOLD</span></div>'
                    : ""
                }


                ${
                  product.tags.includes("on_hold")
                    ? '<div class="ProductItem__LabelList"><span class="ProductItem__Label Heading Text--subdued">ON HOLD</span></div>'
                    : ""
                }

                ${
                  product.tags.includes("onrequest")
                    ? '<div class="ProductItem__LabelList"><span class="ProductItem__Label Heading Text--subdued">PRICE ON REQUEST</span></div>'
                    : ""
                }


                <div class="ProductItem__Info ProductItem__Info--center">
                    <h3 class="ProductCategory__Title Heading u-h2">
                        <a href="/collections/all/${artist} ${medium}">${artist}</a> - 
                        <a href="/collections/all/${artist} ${medium}">${medium}</a>
                    </h3>
                    <h2 class="ProductItem__Title Heading"> 
                        <a href="/collections/all/products/${product.handle}">
                        ${product.title}</a>
                    </h2>
                    ${
  product.tags.includes("priceonrequest")
    ? `<div class="ProductItem__PriceList Heading">
        <span class="ProductItem__Price Price">Price on Request</span>
      </div>`
    : product.totalInventory > 0
                        ? `<div class="ProductItem__PriceList  Heading">
                        <span class="ProductItem__Price Price" prod-price="${formatToCurrency(
                          parseFloat(product.variants.nodes[0].price.amount)
                        )
                          .replace(",", "")
                          .replace(
                            ".",
                            ""
                          )}" data-money-convertible="">£${formatToCurrency(
                            parseFloat(product.variants.nodes[0].price.amount)
                          )}</span>
                    </div>`
                        : ""
                    }
                    
                </div>
            </div>

        </div>

      </div>
    `;

    return template;
  };

  const buildListing = (products, collection) => {
    let template = ``;

    console.log("building for", collection);
    products.forEach((product) => {
      const search = (what) =>
        product.collections.nodes.find((element) => element.handle === what);

      if (
        !product.title.includes("Frame") &&
        product.productType !== "Gift card"
      ) {
        if (collection !== "all" && search(collection)) {
          template += productTemplate(product);
        } else {
          if (collection == "all") template += productTemplate(product);
        }
      }
    });

    return template;
  };

  const updateFilters = (active_tags, current_category) => {
    filterButtons.forEach((elem) => {
      const tag = elem.dataset.tagName;

      if (!tag.toLowerCase().includes(current_category)) {
        if (active_tags.includes(tag)) {
          elem.style.display = "block";
        } else {
          elem.style.display = "none";
        }
      }
    });
  };

  let loading = false;
  let lastpage = false;
  let end_id = "";

  const removeDuplicates = (arr) => [...new Set(arr)];

  const filterUpdate = async (id) => {
    const container = document.getElementById("AjaxinateLoop");
    const dataset = container.dataset;
    const active_tags = dataset.activeTags;
    const active_collection = dataset.activeCollection;
    const sort =
      dataset.sort == "Recommended" ||
      dataset.sort == "manual" ||
      dataset.sort == "best-selling"
        ? ""
        : dataset.sort;

    let active_multiple = [];
    let active_single = [];
    let active_categories = [];

    active_tags.split(",").forEach((tag) => {
      if (tag) {
        category = tag.split("_")[0];
        active_categories.push(category);
      }
    });

    const seen = new Set();
    const duplicates = active_categories.filter(
      (n) => seen.size === seen.add(n).size
    );

    active_tags.split(",").forEach((tag) => {
      if (tag) {
        const category = tag.split("_")[0];
        if (duplicates.includes(category)) active_multiple.push(tag);
        else active_single.push(tag);
      }
    });

    let final = "";

    if (active_multiple.length) final += active_multiple.join(" OR ");

    if (active_single.length && active_multiple.length) final += " AND ";

    if (active_single.length) final += active_single.join(" AND ");

    if (final) {
      document.querySelector(".reset-btn").style.display = "block";
    } else {
      document.querySelector(".reset-btn").style.display = "none";
    }

    const hasfinal = final ? true : false;

    final = final
      ? final + (active_collection == "all" ? "" : " and " + active_collection)
      : active_collection == "all"
      ? ""
      : active_collection;

    loading = true;

    const query = hasfinal
      ? getProductsQuery(final, sort, id)
      : getCollectionProductsQuery(active_collection, id);

    const response = await fetchStore(query);
    const json = await response.json();

    console.log("ql", json, query);

    var format = /^[a-zA-Z0-9- ]*$/.test(final);
    console.log("final?", final);

    const products = json.data.products
      ? json.data.products
      : json.data.collection.products;

    const { hasNextPage, endCursor } = products.pageInfo
      ? products.pageInfo
      : products.pageInfo;

    lastpage = !hasNextPage;
    end_id = endCursor;

    const newlist = buildListing(products.nodes, active_collection);
    const request_available_tags = await fetchStore(
      getAvailableTagsQuery(final, sort, id)
    );

    const new_available_tags = await request_available_tags.json();

    let newtags = [];
    new_available_tags.data.products.nodes.forEach((e) => {
      e.tags.forEach((t) => newtags.push(t));
    });

    newtags = removeDuplicates(newtags);

    updateFilters(newtags, current_category);

    container.insertAdjacentHTML("beforeend", newlist);

    var msnry = $(".product-list-wrapper2").isotope({
      stagger: 0,
      sortBy: "original-order",
    });

    msnry.isotope("reloadItems").isotope();

    loading = false;
  };

  filterButtons.forEach((elem) => {
    elem.addEventListener("click", (e) => {
      const tag = elem.dataset.tag;
      if (tag.includes("_")) {
        const category = tag.split("_")[0];
        current_category = category;

        end_id = "";
      }
    });
  });

  document.addEventListener("theme:loading:end", function (event) {
    filterUpdate(end_id);
  });

  filterUpdate(end_id);

  window.onscroll = function (ev) {
    const hitSpot = document.body.offsetHeight - 500;
    if (window.innerHeight + window.scrollY >= hitSpot) {
      if (!lastpage && !loading) {
        console.log("load more product!", end_id);
        filterUpdate(end_id);
      }
    }
  };
  
});
